module.exports = __webpack_public_path__ + "img/app-3-dark.686ffb51.png";